import axios from "axios";
import {
  GetProphoneContactsResponse,
  IProphoneContact,
} from "./types";

export const getProphoneContacts = async (): Promise<IProphoneContact[]> => {
  try {
    const contactResponse = await axios.get<GetProphoneContactsResponse>(
      `${process.env.REACT_APP_SERVER_URL}/api/getProphoneContacts`
    );

    return contactResponse.data.message;
  } catch (e) {
    console.log("error getting phone contacts", e);
    return [];
  }
};
